import React, { Suspense } from 'react';
import { Dispatch } from 'redux';
import { Route, Switch } from 'react-router-dom';
import routesPublic from './RoutesPublic';
import { User } from 'oidc-client';
import { connect } from 'react-redux';
import { ApplicationState } from '../store';

export interface RoutesModuleProps {
  user: User;
  isLoadingUser: boolean;
  dispatch: Dispatch;
  location: any;
}

const DefaultLayout = React.lazy(() => import('../views/DefaultLayout'));

const Routes = () => {
  const loading = () => <div></div>
  
  return (
    <React.Fragment>
      <Suspense fallback={loading()}>
        <Switch>
          {routesPublic.map((route, idx) => {
            return route.component ? (
              <Route
                key={idx}
                path={route.path}
                exact={route.exact}
                component={route.component}
                // render={props => (
                //   <route.component {...props} />
                // )}
                />
            ) : (null);
          })}
          <Route path="/" render={props => <DefaultLayout {...props}/>} />
        </Switch>
      </Suspense>
    </React.Fragment>
  );
};

function mapStateToProps(state: ApplicationState) {
  return {
    user: state.oidc.user,
    isLoadingUser: state.oidc.isLoadingUser,
    location: state.router.location
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    dispatch
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Routes);
